import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApiVisa,
  BranchContainerModel,
  BranchService,
  Pagination,
} from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DropDownService } from '../../services/drop-down-service';

@Component({
  selector: 'blg-select-branch-drop-down-v2',
  templateUrl: './select-branch-drop-down-v2.component.html',
  styleUrls: ['./select-branch-drop-down-v2.component.css'],
})
export class SelectBranchDropDownV2Component implements OnInit {
  @Input() apiVisa: ApiVisa;
  @Input() branch = new FormControl(null, Validators.required);
  @Input() required: boolean;

  @Output() branchChange = new EventEmitter<FormControl>();
  @Output() branchSelected = new EventEmitter<BranchContainerModel>();
  @Input() branchGuids: any[];
  @Input() controlName: string;

  serverSideFiltering = new FormControl();
  currentBranch = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  branchList: any[] = [];
  selectedBranch: any;
  temporaryBranch: any = [];
  filteredBranch: any = [];
  pagination = new Pagination();

  protected _onDestroy = new Subject<void>();

  constructor(
    private branchService: BranchService,
    private dropDownService: DropDownService
  ) {}

  ngOnInit() {
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBranch();
      });

    this.getBranch();

    this.branch.markAsTouched();
  }

  getBranch() {
    let formData = {
      limit: null,
      orderBy: "code",
      order: "ASC",
    };

    Object.assign(formData,
      {
        "filterConditions": [
        {
          "filterColumn": "status",
          "filterValues": ['ACTIVE'],
          "filterOperator": "IN"
        }]
      }
    )

    this.dropDownService
      .get("branch", formData, this.apiVisa)
      .pipe(
        map((resolved) => {
          if (this.branchGuids?.length > 0) {
            this.filteredBranch = resolved.data.filter((record) =>
              this.branchGuids.includes(record.guid)
            );
            this.branchList = resolved.data.filter((record) =>
              this.branchGuids.includes(record.guid)
            );
          } else {
            this.filteredBranch = resolved.data;
            this.branchList = resolved.data;
          }

          if (resolved.data.length === 1) {
            this.branch.setValue(resolved.data[0].guid);
          }

          // sorting
          const sorted = this.filteredBranch.sort((a, b) =>
            a.code < b.code ? -1 : 1
          );

          this.filteredOptions$.next(this.filteredBranch.slice());
        })
      )
      .subscribe();
  }

  filterBranch() {
    if (!this.filteredBranch) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredBranch.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the locations
    this.filteredOptions$.next(
      this.filteredBranch.filter(
        (option) =>
          (option.code
            ? option.code.toLowerCase().indexOf(search) > -1
            : null) ||
          (option.name ? option.name.toLowerCase().indexOf(search) > -1 : null)
      )
    );
  }

  onSelect(branchGuid: string) {
    if (branchGuid) {
      this.branch.patchValue(branchGuid);
      this.branchService
        .getByGuid(branchGuid, this.apiVisa)
        .subscribe((response) => {
          this.selectedBranch = response.data;
          this.branchSelected.emit(this.selectedBranch);
        });
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
